import { $t } from "~/i18n.js";

export const FORMULA_OPTIONS = () => (
    [
        { value: "sqrt", label: $t("Starts & uren (√)") },
        { value: "hours", label: $t("Alleen uren") },
        { value: "starts", label: $t("Alleen starts") },
        { value: "fixed", label: $t("Vast aantal uren") },
        { value: "empty", label: $t("Geen berekening (open periode)") },
    ]
);

export const FORMULA_EXPLANATIONS = () => (
    {
        sqrt: $t("Onderhoudsformule = factor * √ (starts op clubkisten * uren op clubkisten)"),
        hours: $t("Onderhoudsformule = factor * uren op clubkisten"),
        starts: $t("Onderhoudsformule = factor * starts op clubkisten"),
        fixed: $t("Vaste onderhoudsuren per lid"),
        empty: $t("Geen automatische berekening; uren worden handmatig per lid vastgesteld."),
    }
);
